var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.tableList,"height":"100%","stripe":"","border":"","size":"mini","header-cell-style":{
    'font-weight': 'bold',
    color: '#333',
    'background-color': '#F7F7F7',
  }}},_vm._l((_vm.tableHead),function(v,i){return _c('el-table-column',{key:i,attrs:{"prop":v.prop,"label":v.label,"align":"center"}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }